export default "__VITE_ASSET__DTbIycqG__"